
define("rv!templates/partials/nightlyRates",[],function(){return { v:3,
  t:[ { t:7,
      e:"strong",
      f:[ "Nightly Rates" ] },
    " ",
    { t:7,
      e:"table",
      a:{ "class":"table table-condensed table-bordered" },
      f:[ { t:7,
          e:"tr",
          f:[ { t:7,
              e:"th",
              f:[ "Date" ] },
            " ",
            { t:7,
              e:"th",
              f:[ "Rate" ] } ] },
        " ",
        { t:4,
          f:[ { t:7,
              e:"tr",
              f:[ { t:7,
                  e:"td",
                  f:[ { t:2,
                      x:{ r:[ "formatDate",
                          "ReservationDate" ],
                        s:"_0(_1,\"ddd M/d/yyyy\")" } } ] },
                " ",
                { t:7,
                  e:"td",
                  f:[ { t:2,
                      x:{ r:[ "formatMoney",
                          "Rate" ],
                        s:"_0(_1)" } } ] } ] } ],
          n:52,
          r:"Nights" } ] } ] };});
